import {observable, action, computed, createTransformer, reaction, extendObservable} from "mobx";
import _ from 'lodash';
import moment from "moment";
import DetalhamentoContratacaoStore from "../../solicitacao_contratacao/stores/FluxoSolicitacaoStore";
import FluxoStore from "../../comum/stores/FluxoStore";

export default class FluxoSubstituicaoStore extends FluxoStore {
    @observable solicitacaoSubstituicao;
    @observable dataInicioSubstituicaoValidacao;
    @observable momentDataInicioSubstituicao;
    @observable loadingCpfSubstituicao;
    @observable cpfSubstituicaoValidacao;
    @observable irParaSolicitacaoTerminoAntecipado;
    @observable isSolicitacaoSubstituicao;
    @observable alertaValidacaoCPF;
    @observable obstrucaoValidacaoCPF;

    constructor(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore) {
        super(parametrosGeraisStore, loginStore, tituloPaginaStore, validationStore, modalStore, loadingPanelStore);
        this.dataInicioSubstituicaoValidacao = null;
        this.momentDataInicioSubstituicao = null;
        this.resetDadosSubstituicaoMOT();
        this.loadingCpfSubstituicao = false;
        this.irParaSolicitacaoTerminoAntecipado = false;

        this.alertaValidacaoCPF = [];
        this.obstrucaoValidacaoCPF = [];
    }

    @computed
    get razaoEDataSubstituicaoMOTEditavel() {
        return this.nomeTarefa !== "HT_ETTInformaRecurso";
    }

    @computed
    get dadosMOTDetalhamentoEditavel() {
        return this.nomeFluxo === "GloboMOTSubstituicao" && this.nomeTarefa === "HT_ETTInformaRecurso"
    }

    @computed
    get exibeDetalhamentoSubstituicao() {
        return this.nomeFluxo === "GloboMOTSubstituicao" && this.nomeTarefa !== "HT_ETTInformaRecurso";
    }

    @computed
    get exibeDadosMOTDetalhesSubstituicao() {
        return this.nomeTarefa === "HT_ETTInformaRecurso";
    }

    @computed
    get exibeDadosMOTSubstituicaoDetalhamento() {
        return (this.solicitacaoSubstituicao.dadosMot && this.solicitacaoSubstituicao.dadosMot.cpf) || this.nomeTarefa === "HT_ETTInformaRecurso";
    }

    resetDadosSubstituicaoMOT = () => {
        this.solicitacaoSubstituicao = {
            razao: "",
            dataSolicitacao: null,
            dadosMot: {
                cpf: "",
                nome: "",
                email: "",
                telefone: "",
                identidade: "",
                orgaoEmissor: "",
                tipoSanguineo: "",
                endereco: {
                    rua: "",
                    numero: "",
                    complemento: "",
                    bairro: "",
                    cidade: "",
                    uf: "",
                    cep: ""
                }
            }
        };
    };

    toggleIrParaSolicitacaoTerminoAntecipado = () => {
        this.irParaSolicitacaoTerminoAntecipado = !this.irParaSolicitacaoTerminoAntecipado
    };

    informarNovoRecurso = (id) => {
        if (id) {
            if (this.tarefaPermiteAtualizarPayload()) {
                this.detalhesTarefa.solicitacaoEtt = this.confirmarAlocacaoETT;
                this.detalhesTarefa.solicitacao.matriculaAprovadoresExtra = this.apenasMatriculaAprovadoresExtraValidos;
                this.detalhesTarefa.solicitacaoSubstituicao = this.solicitacaoSubstituicao;
            }
            return this.tarefaService.tramitar(id, this.nomeFluxo, this.idSolicitacao, "CONFIRMAR_SUBSTITUICAO", null, this.observacoes, this.detalhesTarefa);
        }
    };

    setSubstituicaoLoadingCpf = (value) => {
        this.loadingCpfSubstituicao = value;
    };

    atualizaDadosMotSubstituicaoContratosAntigo = (dadosAntigos) => {
        this.atualizaDadosMotContratosAntigo(this.solicitacaoSubstituicao.dadosMot, dadosAntigos);
    };

    substituir = () => {
        return this.tarefaService.iniciarFluxoSubstituicao({idSolicitacaoEtt: this.idSolicitacao, ...this.solicitacaoSubstituicao});
    };

    //override
    carregarDadosExtras = (response, carregandoDadosPor, dadosUrl) =>  {
        if ((carregandoDadosPor === "taskId" || carregandoDadosPor === "andamentoSubstituicao") && response.solicitacaoSubstituicao) {
            this.solicitacaoSubstituicao.dataSolicitacao = response.solicitacaoSubstituicao.dataSolicitacao;
            this.solicitacaoSubstituicao.razao = response.solicitacaoSubstituicao.razao;
            this.solicitacaoSubstituicao.idSolicitacao = response.solicitacaoSubstituicao.idSolicitacao;
            this.solicitacaoSubstituicao.usuarioSolicitante = response.solicitacaoSubstituicao.usuarioSolicitante;

            if(response.solicitacaoSubstituicao.dadosMot) {
                this.solicitacaoSubstituicao.dadosMot = response.solicitacaoSubstituicao.dadosMot;
            }
        }
    };

    setDataSubstituicao = (value) => {
        let date = value;
        if(date) {
            date = moment(date.format('DD/MM/YYYY'), "DD/MM/YYYY");

            this.momentDataInicioSubstituicao = date;
            this.solicitacaoSubstituicao.dataSolicitacao = date.toJSON();
            this.dataInicioSubstituicaoValidacao = date.format('DD/MM/YYYY');
        } else {
            this.momentDataInicioSubstituicao = null;
            this.solicitacaoSubstituicao.dataSolicitacao = null;
            this.dataInicioSubstituicaoValidacao = null;
        }
    };

    //substituicao
    setRazaoSubstituicao = (value) => {
        this.solicitacaoSubstituicao.razao = value;
    };

    setCpfSubstituicao = (motCPF, value) => {
        const dadosMot = this.solicitacaoSubstituicao.dadosMot;
        dadosMot.cpf = value;
        if (value.length === 11) {
            this.validarCpfMOT(value, this.setSubstituicaoLoadingCpf, this.atualizaDadosMotSubstituicaoContratosAntigo);
        } else {
            this.alertaValidacaoCPF = [];
            this.obstrucaoValidacaoCPF = [];
        }
    };

    setTelefoneSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.telefone = value;
    };

    setCEPSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.cep = value;
    };

    setEmailSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.email = value;
    };

    setEnderecoBairroSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.bairro = value;
    };

    setEnderecoCidadeSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.cidade = value;
    };

    setEnderecoComplementoSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.complemento = value;
    };

    setEnderecoNumeroSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.numero = value;
    };

    setEnderecoRuaSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.rua = value;
    };

    setEnderecoUFSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.endereco.uf = value;
    };

    setIdentidadeSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.identidade = value;
    };

    setNomeSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.nome = value;
    };

    setOrgaoEmissorSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.orgaoEmissor = value;
    };

    setTipoSanguineoSubstituicao = (value) => {
        this.solicitacaoSubstituicao.dadosMot.tipoSanguineo = value;
    };

    setDataInicioSubstituicaoCheck = (value) => {
        this.dataInicioSubstituicaoValidacao = value;
        if(!value) {
            this.solicitacaoSubstituicao.dataSolicitacao = null;
            this.dataInicioSubstituicaoValidacao = null;
        }
    }

}